<template>
  <div class="kpb-media-trigger" ref="root">
    <PhotoSwipe v-show="false" class="kpb-media-trigger__swipe" :data="data"></PhotoSwipe>
    <ButtonComponent class="kpb-media-trigger__button" :label="label" v-bind="$attrs" @click="trigger" />
  </div>
</template>

<script>
import PhotoSwipe from './Photoswipe.vue'

/** Gallery component */
export default {
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    label: {
      type: String,
      default: 'Open',
    },
  },

  computed: {
    layoutComponent() {
      return LayoutComponents[this.variant]
    },

    contentComp() {
      return this.$path('content', this.data) || this.$path('images', this.data)
    },
  },
  methods: {
    trigger() {
      let firstSlide = this.$refs.root.querySelector('.kpb-photoswipe__item')
      if (!firstSlide) return
      firstSlide.click()
    },
  },

  components: {
    PhotoSwipe,
  },
}
</script>

<style lang="scss"></style>
